export const messages = {
  title: '日程',
  today: '今天',
  prevDay: '前一天',
  nextDay: '后一天',
  prevWeek: '上一周',
  nextWeek: '下一周',
  weekView: '周视图',
  dayView: '日视图',
  loading: '加载中…',
  emptyDay: '今天没有安排',
  emptyDate: '这一天没有安排',
  emptyWeek: '本周暂无计划',
  loadFailed: '加载失败',
  retry: '重试',
  categoryTimeline: '时间线板块',
  categoryWorkPlan: '工作计划',
  categoryTrainingPlan: '训练计划',
  categoryMealPlan: '饮食计划',
  categoryLearningPlan: '学习计划',
  categoryLife: '生活事项',
  typeTraining: '训练',
  typeWork: '工作',
  typeLearning: '学习',
  typeFixed: '固定',
  typeDdl: 'DDL',
  typeMeal: '饮食',
  distance: '距离',
  paceZone: '配速',
  heartRateZone: '心率',
  totalKcal: '总计 {kcal} kcal',
  kcal: '{kcal} kcal',
  mealNoDetails: '暂无饮食明细',
  ddlDueToday: '今天截止',
  ddlDaysLeft: '剩 {n} 天',
  ddlOverdue: '已过期 {n} 天',
  remindBefore: '截止前一天提醒',
  note: '备注',
  itemsCount: '{count} 项',
  weekItemsCount: '{count} 项',
  back: '返回',
  heldTasks: '搁置',
  noHeldTasks: '没有搁置的任务',
  blockedTasks: '阻塞',
  noBlockedTasks: '没有阻塞的任务',
  inProgressTasks: '已开始',
  noInProgressTasks: '没有进行中的任务',
  pendingTasks: '未开始',
  noPendingTasks: '没有未开始的任务',
  overdueTasks: '已延期',
  noOverdueTasks: '没有延期的任务',
  heldFor: '已搁置 {days} 天',
  restore: '恢复',
  cancel: '取消',
  viewHeldTasks: '查看搁置任务',
  rangeSpan: '{from}–{to} · {n} 天',
  rangeDayProgress: '第 {k}/{n} 天',
  rangeLastDay: '最后一天'
} as const
